<template>
  <div class="pages-pagination-container">
    <div class="row pages-pagination-wrapper">
      <div class="col-4">
        <button
          ref="prev"
          v-if="previousPageEnabled"
          class="pages-pagination--previous"
          @click="handlePreviousPageClick"
        >
          <img src="@/assets/images/ic_arrow_left_black.svg" alt="icon"/>
          <span>{{ $t('viewer.page.prev.button') }}</span>
        </button>
      </div>

      <div class="col-4 pages-pagination--pager">
        <strong>{{ pagination.page }}</strong> / {{ pagination.totalPages }}
      </div>

      <div class="col-4">
        <button
          ref="next"
          class="pages-pagination--next"
          @click="handleNextPageClick"
          :disabled="!isEnableNextButton"
        >
          <template v-if="!busy">
            <span>{{ $t('viewer.page.next.button') }}</span>
            <img src="@/assets/images/ic_arrow_right_primary.svg" alt="icon"/>
          </template>
          <LoadingBounce v-else></LoadingBounce>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'new-class-preview-pages-pagination',

  props: ['pagination'],

  data() {
    return {
      busy: false,
    };
  },

  computed: {
    ...mapGetters({
      page: 'getCurrentPageForNewClass',
      cardId: 'getCardIdForNewClass',
    }),

    previousPageParams() {
      return { page: this.pagination.page - 1 };
    },

    nextPageParams() {
      return { page: this.pagination.page + 1 };
    },

    previousPageEnabled() {
      return this.pagination.page > 1;
    },

    isLastPage() {
      return this.pagination.page === this.pagination.totalPages;
    },

    isNextPage() {
      return this.pagination.page < this.pagination.totalPages;
    },

    isEnableNextButton() {
      return this.isNextPage;
    },
  },

  methods: {

    handleNextPageClick() {
      if (this.isNextPage) {
        this.$router.replace({
          name: 'new-class-preview-pages.show',
          params: this.nextPageParams,
        });
      } else {
        this.busy = false;
      }
    },

    handlePreviousPageClick() {
      return this.$router.replace({
        name: 'new-class-preview-pages.show',
        params: this.previousPageParams,
      });
    },
  },

  watch: {
    $route() {
      if (this.busy) {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/components/_typographies";
@import "../../../assets/styles/components/_breakpoints";

@mixin pages-button {
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  height: 40px;
  width: 108px;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);

  @media (min-width: $desktop-breakpoint) {
    width: 160px;
    height: 48px;
    font-size: 20px;
  }

  span {
    font-weight: bold;
  }

  img {
    width: 12px;
    height: 12px;
    margin: 0 0 2px 0;

    @media (min-width: $desktop-breakpoint) {
      width: 16px;
      height: 16px;
    }
  }

  &:disabled {
    box-shadow: none;
    color: #aaaaaa;
  }
}

.pages-pagination-container {
  background-color: #ffffff;
  padding: 18px 0 18px 0;
  text-align: center;
  z-index: 100;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 14px;
  font-weight: 100;

  @media (min-width: $desktop-breakpoint) {
    font-size: 18px;
  }
}

.pages-pagination-wrapper {
  max-width: 570px;
  margin: 0 auto;
}

.pages-pagination--pager {
  color: #808080;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pages-pagination--pending {
  float: right;
  @include pages-button;

  span {
    margin-right: 14px;
    font-weight: 400;
  }
}

.pages-pagination--next {
  @include pages-button;
  float: right;
  text-decoration: none;
  color: #00c896;

  span {
    margin-right: 6px;
  }
}

.pages-pagination--next:active {
  color: #00c896;
}

.pages-pagination--next:focus {
  outline: none;
}

.pages-pagination--previous {
  float: left;
  text-decoration: none;
  @include pages-button;

  span {
    margin-left: 6px;
  }
}

.pages-pagination--previous:active {
  box-shadow: none;
}

.pages-pagination--previous:focus {
  outline: none;
}
</style>
